<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="text-xs-right">
          <v-btn flat fab :loading="saveLoading" @click="handleCancel">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-layout wrap>
          <v-flex
            xs12
            sm12
            class="form-control px-1"
            :class="{ 'has-error': errors.has('campaignName') }"
          >
            <div class="caption mb-1">ชื่อแคมเปญ <span class="red--text">*</span></div>
            <input
              v-model="input.campaign_name"
              v-validate="'required'"
              type="text"
              data-vv-as="ชื่อแคมเปญ"
              class="form-control"
              maxlength="255"
              name="campaignName"
              style="width: 100%"
            />
            <p v-if="errors.has('campaignName')" class="text-error">
              {{ errors.first('campaignName') }}
            </p>
          </v-flex>
        </v-layout>
        <div class="text-xs-center mt-3">
          <v-btn outline color="grey" :loading="saveLoading" @click="handleCancel">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed :loading="saveLoading" @click="handleSubmit">{{
            $t('Save')
          }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      input: {
        campaign_name: ''
      },
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleSubmit() {
      const vm = this
      try {
        if (await vm.$validator.validate()) {
          let data = {
            page_id: vm.selectedBot.pageid,
            name: vm.input.campaign_name
          }

          vm.saveLoading = true
          const response = await toaCrmApi.createCampaign({ data: data })
          vm.saveLoading = false

          if (response && response.status === 200) {
            const recentlyCreated = response.data && response.data.data[0]
            await vm.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            vm.clearForm()
            vm.$emit('success', recentlyCreated)
          } else {
            await vm.$swal.fire({
              text: response.data.reason,
              type: 'error'
            })
          }
        }
      } catch (error) {
        vm.saveLoading = false
        console.error(error)
      }
    },
    clearForm() {
      this.input = {
        campaign_name: ''
      }
    },
    handleCancel() {
      this.clearForm()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/CampaignManageDialog.vue